<template>
  <div class="flex flex-col gap-12">
    <div
      v-for="spec in specifications"
      :key="spec.label"
      class="flex flex-col gap-1"
    >
      <div>
        <ul class="flex list-none flex-wrap items-center gap-4 pt-2">
          <li v-for="value in spec.values" :key="value">
            <RevTag :label="value" variant="secondary" variation="outline" />
          </li>
        </ul>
      </div>
    </div>
  </div>
</template>

<script lang="ts" setup>
import { RevTag } from '@ds/components/Tag'

defineProps<{
  specifications: Array<{
    label: string
    values: string[]
  }>
}>()
</script>
